var map = {
	"./daocheng-yading/metadata.json": 8361,
	"./jiuzhaigou-valley/metadata.json": 2614,
	"./kanas-lake-xinjiang/metadata.json": 7230,
	"./pingtan-island/metadata.json": 2172,
	"./shangli-ancient-town/metadata.json": 2715,
	"./wuyuan-countryside/metadata.json": 1174,
	"./yangshuo-li-river/metadata.json": 5980
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3652;